



























import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { area } from '@/common/address.js'
@Component({
    components: {
      
    },
})
export default class selectAddressPanel extends Vue {
    public $refs: {
    };
    columnsUnit= [];
    
    show = false;
    /**省市区 */
    addressShow = false;
    addressColumns = [];
   

    created() {
    }
    mounted() {
     
        
    }

    moveHandle() {}

    //确定选中的地区
    async onConfirmAddress(value){
        console.log('value',value);
        this.$emit('onConfirmAddress',JSON.stringify(value))
        this.show = false;
        
    }
    onCancelAddress(){
        this.show = false;
    }
   
    async showFun(){
        await this.init();
        this.show = true;
    }

    onChange(picker, values,index){
        console.log('picker, values,index',picker, values,index);
        if(index==0){
            picker.setColumnValues(1, Object.keys(area[values[0]][0]));
            let areaw = [];
            area[values[0]][0][Object.keys(area[values[0]][0])[0]].forEach(e => {
                areaw.push(Object.keys(e)[0])
            });
            picker.setColumnValues(2, areaw);
        }
        if(index==1){
            let areaw = [];
            area[values[0]][0][values[1]].forEach(e => {
                areaw.push(Object.keys(e)[0])
            });
            picker.setColumnValues(2, areaw);
        }
    }

    async init(){
        let province = Object.keys(area);
        let city = Object.keys(area['河南省'][0]);
        let areaw = [];
        area['河南省'][0]['郑州市'].forEach(e => {
            areaw.push(Object.keys(e)[0])
        });
        this.addressColumns = [
            {values:province,className: 'column1',},
            {values:city,className: 'column2',},
            {values:areaw,className: 'column3',},
        ]
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/selectAddressPanel.vue